import { render, staticRenderFns } from "./contractAdd.vue?vue&type=template&id=2d9a8cd8&scoped=true"
import script from "./contractAdd.vue?vue&type=script&lang=js"
export * from "./contractAdd.vue?vue&type=script&lang=js"
import style0 from "./contractAdd.vue?vue&type=style&index=0&id=2d9a8cd8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d9a8cd8",
  null
  
)

export default component.exports